import script from "./catalogservices.vue?vue&type=script&setup=true&lang=ts"
export * from "./catalogservices.vue?vue&type=script&setup=true&lang=ts"

import "./catalogservices.vue?vue&type=style&index=0&id=1f1eccca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1eccca"]])

export default __exports__